<!-- Banner displayed on mobile for warning of functionalities. On close, store in local storage so that it does not display anymore
-->

<script setup lang="ts">
/* UTILS */
/* AF-LIB HELPERS */
import { ref } from 'vue';

/* COMPONENTS */
import { ALAlert } from '@af-lib/vue-ui';

const isBannerDisplayed = ref(true);

const closeBanner = () => {
  isBannerDisplayed.value = true;
};
</script>

<template>
  <ALAlert
    v-if="isBannerDisplayed"
    class="banner"
    :description="$t('notifications.temp.limited_access')"
    type="info"
    :isDismissible="true"
    @close="closeBanner"
  />
</template>

<style scoped lang="scss">
.banner {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
}
</style>
